<template>
  <form class="c-plan-form__sim-type">
      <div
        v-for="(option, index) in localData.options"
        :key="option.option_type_id + index"
        :class="['custom-control custom-radio', index > 0 ? ' u-marg-b-0' : '', planDataFromMagento.plan.categorization === 'homebox' ? '' : 'gtm-configurateur-SIM-choice']">

        <input
          :checked="checkedStatus"
          class="custom-control-input"
          type="radio"
          :name="`options[${option.option_id}]`"
          v-model="optionModel.value"
          :id="`${option.sku}-${index}`"
          :value="option.sku"
          @change="onChange(option)">

        <label
          class="custom-control-label"
          :for="`${option.sku}-${index}`">
          {{ option.name }}
        </label>

        <p
          v-if="option.description && option.description.length > 0"
          class="u-marg-t-xxs u-marg-b-xxs u-grey-text">{{ option.description }}</p>

        <a
          v-if="option.sku === 'OfferESIMCardPostpaid'"
          data-toggle="modal"
          :data-target="`#${option.popin}-modal`"
          class="c-plan-form__link u-grey-text u-bold">
            {{ option.popin === 'esim_popin_phone' ? $t('Learn more') : $t('See compatible phone models') }} >
        </a>

      </div>

      <a
        @click.prevent="setStep"
        id="prev-step"
        href="#"
        class="btn btn-secondary btn-lg mr-1 mr-sm-3">
        {{ 'Back' }}
      </a>

      <a
        :tabindex="addToCartButtonState.tabindex"
        role="button"
        id="validate-plan"
        :aria-disabled="addToCartButtonState.disabled"
        @click="validatePlan"
        :href="planDataFromMagento.cartUrl"
        :class="['btn btn-lg btn-primary', addToCartButtonState.disabled ? 'disabled' : '']">
          <span>{{ localData.validatePlan }}</span>
          <img
            v-show="addToCartButtonState.disabled"
            :src="planDataFromMagento.loaderUrl"
            class="u-marg-l-xxs"
            style="max-width: 16px;"
            alt=""/>
      </a>
  </form>
</template>

<script>
  import Helpers from '~plugins/Helpers'
  export default {
    props: {
      planDataFromMagento: {
        type: Object,
        default: () => undefined
      },
      traduction: {
        type: Function
      },
      dataFromCart: {
        type: Object,
        default: () => null
      }
    },
    computed: {
      $t () {
        return this.traduction
      }
    },
    data () {
      return {
        optionModel: {
          label: 'SIMCard',
          value: 'SIMCard',
          option_id: '',
          option_type_id: ''
        },
        addToCartButtonState: {
          tabindex: 1,
          disabled: false
        },
        localData: {
          discoverSim: 'Découvrir la eSIM',
          validatePlan: 'Valider mon forfait',
          options: []
        }
      }
    },
    beforeMount () {
      // If planDataFromMagento is not undefined, we are in production mode
      // so replace locale data with real data
      if (this.planDataFromMagento) {
        let customOptions = this.planDataFromMagento.plan.custom_options.sim_type.options

        /**
         * If eSim is available AND the user come from a device always choose the eSim first
         * If the user doesn't come from a device it means he comes from a single plan so we push the classic SIMCard
         * If not we select the first option
         */
        for (let i = 0; i < customOptions.length; i++) {
          if (customOptions[i].sku === 'OfferESIMCardPostpaid' && this.planDataFromMagento.isFromDevice) {
            this.optionModel = {
              label: customOptions[i].sku,
              value: customOptions[i].sku,
              option_id: customOptions[i].option_id,
              option_type_id: customOptions[i].option_type_id,
              popin: 'esim_popin_phone'
            }
          } else if (customOptions[i].sku === 'OfferSIMCardPostpaid' && !this.planDataFromMagento.isFromDevice) {
            this.optionModel = {
              label: customOptions[i].sku,
              value: customOptions[i].sku,
              option_id: customOptions[i].option_id,
              option_type_id: customOptions[i].option_type_id,
              popin: 'esim_popin_sim_only'
            }
          } else {
            this.optionModel = {
              label: customOptions[0].sku,
              value: customOptions[0].sku,
              option_id: customOptions[0].option_id,
              option_type_id: customOptions[0].option_type_id,
              popin: 'esim_popin_sim_only'
            }
          }
        }

        this.localData.discoverSim = this.$t('Learn more about eSIM')
        this.localData.validatePlan = this.$t('Confirm plan settings')

        if (this.planDataFromMagento.plan.categorization === 'homebox') {
          customOptions = this.planDataFromMagento.plan.custom_options.modem.options

          this.optionModel = {
            label: customOptions[0].sku,
            value: customOptions[0].sku,
            option_id: customOptions[0].option_id,
            option_type_id: customOptions[0].option_type_id
          }
        }

        this.localData.options = customOptions

        this.localData.options = this.localData.options.map(option => {
          if (option.sku === 'OfferESIMCardPostpaid') {
            if (this.planDataFromMagento.isFromDevice) {
              return {
                sku: 'OfferESIMCardPostpaid',
                description: this.$t('The phone you chose is compatible with eSIM. If you would rather receive a standard SIM card, please select that option instead. With eSIM, you no longer need a physical SIM card. You line will be activated by scanning a QR code with your phone.'),
                option_id: option.option_id,
                option_type_id: option.option_type_id,
                popin: 'esim_popin_phone',
                name: option.name
              }
            } else {
              return {
                sku: 'OfferESIMCardPostpaid',
                description: this.$t('With eSIM, you no longer need a physical SIM card. Your line will be activated by scanning a QR code with your phone. Please check that your phone is compatible.'),
                option_id: option.option_id,
                option_type_id: option.option_type_id,
                popin: 'esim_popin_sim_only',
                name: option.name
              }
            }
          } else {
            option.popin = 'esim_popin_sim_only'
            return option
          }
        })

        /**
         * If the user came the button modify from his cart
         */
         if (this.dataFromCart) {
          let optionFromCart = this.localData.options.find(option => this.dataFromCart.sku === option.sku)

          this.optionModel = {
            ...optionFromCart,
            label: this.dataFromCart.sku,
            value: this.dataFromCart.sku
          }
        }


      }
    },
    methods: {
      checkedStatus (option) {
        return this.optionModel.sku === option.sku
      },
      onChange (currentOption) {
        this.optionModel = currentOption
      },
      setStep(){
        this.$emit('set-step', true)
      },
      validatePlan (el) {
        el.preventDefault()
        this.$emit('validate-plan', this.optionModel)

        Helpers.pushDataLayer({
          'event': 'Configurator field',
          'click_name': 'Steps 2',
          'click_category': 'Obligatoire'
        })

        // Disabled button to avoid user to spam the button
        // and signal the user we add the product to the cart
        this.addToCartButtonState.disabled = true
        this.addToCartButtonState.tabindex = -1
      }
    }
  }
</script>
